import { WithdrawalsSetLimitsProcessedItemsReducer } from './types';

export const withdrawalsSetLimitsProcessedItemsReducer: WithdrawalsSetLimitsProcessedItemsReducer =
  (state, action) => {
    const { withdrawalsLimits } = action.payload;

    return {
      ...state,
      withdrawalsLimitsProcessedItems: withdrawalsLimits,
    };
  };
